import * as React from "react";
import { useState } from "react";
import { Collapse, ExpandIcon, IconComponent, Pressable, Text, TextVariant } from "../../../../ui";
import { usePrefersReducedMotion } from "../../../../../hooks/usePrefersReducedMotion";

let nextSectionId = 0;

// A step darker than the body, but not the card header's #1f2b3a: the first section sits right under that bar.
export const SECTION_HEADER_BACKGROUND = "#243246";
const DIVIDER = "#44576e";
const TITLE_COLOR = "#e2e8f0";

export const CollapsibleSection: React.FC<{
  title: string;
  /** Marks the header row, so it reads apart from the content below it. */
  Icon: IconComponent;
  open: boolean;
  onToggle: () => void;
}> = ({ title, Icon, open, onToggle, children }) => {
  const [bodyId] = useState(() => `job-card-section-${(nextSectionId += 1)}`);
  const reduceMotion = usePrefersReducedMotion();
  const duration = reduceMotion ? 0 : 220;
  return (
    <section className="border-t border-[#44576e] first:border-t-0">
      <Pressable
        aria-expanded={open}
        aria-controls={bodyId}
        onClick={onToggle}
        className="w-full"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
          minHeight: 44,
          padding: "0 12px",
          backgroundColor: SECTION_HEADER_BACKGROUND,
          // Closed, the next section's top border (or the card's edge) already separates it.
          borderBottom: open ? `1px solid ${DIVIDER}` : undefined,
        }}
      >
        <Icon aria-hidden style={{ color: TITLE_COLOR, fontSize: "1.125rem", flexShrink: 0 }} />
        <Text
          variant={TextVariant.BODY2}
          as="span"
          style={{ fontWeight: 600, color: TITLE_COLOR, flex: 1, minWidth: 0, textAlign: "left" }}
        >
          {title}
        </Text>
        <ExpandIcon
          aria-hidden
          style={{
            color: "#94a3b8",
            flexShrink: 0,
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: `transform ${duration}ms ease`,
          }}
        />
      </Pressable>
      {/* Always present, so aria-controls points at an element even while the body is closed. */}
      <div id={bodyId}>
        <Collapse open={open} durationMs={duration} unmountOnClose>
          <div className="px-3 pb-1">{children}</div>
        </Collapse>
      </div>
    </section>
  );
};
